
<ng-template
    [ngIf]="blockTypeGroups"
>
    @for (blockGroup of blockTypeGroups; track blockGroup; let gi = $index) {
        <div
            [id]="id + '_blockGroup_' + gi"
            class="agpr-blockAdder-container"
        >
            @if (blockGroup.header) {
                <div>{{ blockGroup.header | localize }}</div>
            }
            <ul class="agpr-blockAdder">
                @for (blockType of blockGroup.blockTypes; track blockType; let i = $index) {
                    @if (blockType.showInBlockAdder && !hideBlockTypes.includes(blockType.key)) {
                        @if (draggable) {
                            <li class="agpr-blockAdder-item agpr-blockAdder-item--draggable">
                                <agpr-button
                                    #addBlockButton
                                    [id]="id + '_blockType_' + blockType.key"
                                    [tooltip]="blockType.canAdd ? blockType.label : blockType.reachLimitMessage | localize"
                                    tooltipPosition="top"
                                    [ariaLabel]="(blockType.label | localize) + ('PageBuilder.block' | localize)"
                                    [disabled]="!blockType.canAdd"
                                    [dndDraggable]="blockType"
                                    dndEffectAllowed="copy"
                                    dndType="blockType"
                                    [dndDisableIf]="!blockType.canAdd "
                                    (dndStart)="onDragBlockTypeStart(blockType)"
                                    (dndEnd)="onDragBlockTypeComplete()"
                                    (click)="addBlock(blockType, $event)"
                                    [style]="buttonTypes.big"
                                >

                                    <div class="agpr-blockAdder-item-dragHandle">
                                        <span class="agpr-blockAdder-item-dragHandle-icon"></span>
                                    </div>
                                    <div class="agpr-blockAdder-item-label">
                                        <span
                                            class="agpr-button-icon"
                                            [ngClass]="blockType.icon"
                                            aria-hidden="true"
                                        ></span>
                                        <span class="agpr-button-label">{{ blockType.label | localize }}</span>
                                        @if (blockType.remainingCount || blockType.remainingCount === 0) {
                                            <span class="agpr-blockAdder-remaining">{{ blockType.remainingCount }}</span>
                                        }
                                    </div>

                                    @if (blockType.isLocked) {
                                        <span
                                            class="agpr-blockAdder-item-lock fa-solid fa-lock"
                                            aria-hidden="true"
                                        ></span>
                                    }
                                </agpr-button>
                            </li>
                        } @else {
                            <li class="agpr-blockAdder-item">
                                <agpr-button
                                    [id]="id + '_blockType_' + blockType.key"
                                    [icon]="blockType.icon"
                                    [label]="blockType.label"
                                    [tooltip]="blockType.canAdd ? blockType.label : blockType.reachLimitMessage | localize"
                                    tooltipPosition="top"
                                    [ariaLabel]="(blockType.label | localize) + ('PageBuilder.block' | localize)"
                                    [disabled]="!blockType.canAdd"
                                    (click)="addBlock(blockType, $event)"
                                    [style]="buttonTypes.big"
                                >
                                    @if (blockType.remainingCount || blockType.remainingCount === 0) {
                                        <span class="agpr-blockAdder-remaining">{{ blockType.remainingCount }}</span>
                                    }
                                    @if (blockType.isLocked) {
                                        <span
                                            class="agpr-blockAdder-item-lock fa-solid fa-lock"
                                            aria-hidden="true"
                                        ></span>
                                    }
                                </agpr-button>
                            </li>
                        }
                    }
                }
            </ul>
        </div>
    }
</ng-template>

<ng-template
    [ngIf]="!blockTypeGroups"
>
    <ul class="agpr-blockAdder">
        @for (blockType of blockTypes; track blockType; let i = $index) {
            @if (blockType.showInBlockAdder && !hideBlockTypes.includes(blockType.key)) {
                <li class="agpr-blockAdder-item">
                    <button
                        class="agpr-blockAdder-itemButton"
                        [id]="id + '_blockType_' + blockType.key"
                        pButton
                        iconPos="left"
                        [label]="blockType.label | localize"
                        [agprTooltip]="blockType.canAdd ? blockType.label : blockType.reachLimitMessage | localize"
                        tooltipPosition="top"
                        [icon]="blockType.icon"
                        [disabled]="!blockType.canAdd"
                        (click)="addBlock(blockType)"
                    ></button>
                </li>
            }
        }
    </ul>
</ng-template>
